import { EvaluationMark } from '../enums/EvaluationMark';

export const EvalMarkTitleByValue = {
  [EvaluationMark.NeedsDevelopment]: 'Needs development',
  [EvaluationMark.Successful]: 'Successful',
  [EvaluationMark.Exceeds]: 'Exceeds',
  [EvaluationMark.CantEval]: "Can't evaluate",
};
